import React, { useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "Wedding",
    date: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you! We'll get back to you soon.");
    setFormData({ name: "", email: "", service: "Wedding", date: "", message: "" });
  };

  return (
    <section id="contact" className="bg-gradient-to-b from-gray-950 to-black py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Side */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
              <p className="text-xs uppercase tracking-[4px] text-amber-400 font-bold">
                Get In Touch
              </p>
            </div>
            <h2 className="text-5xl md:text-6xl font-black text-white mb-8">
              Ready to Book Your Session?
            </h2>
            <p className="text-lg text-gray-300 mb-12 leading-relaxed">
              Let's create something beautiful together. Reach out to us and let's discuss your photography needs.
            </p>

            <div className="space-y-8">
              <div>
                <p className="text-sm uppercase tracking-[3px] text-amber-400 font-bold mb-2">
                  Email
                </p>
                <a href="mailto:hello@studio44.com" className="text-xl text-white hover:text-amber-400 transition font-medium">
                  hello@studio44.com
                </a>
              </div>
              <div>
                <p className="text-sm uppercase tracking-[3px] text-amber-400 font-bold mb-2">
                  Phone
                </p>
                <a href="tel:+918248238436  " className="text-xl text-white hover:text-amber-400 transition font-medium">
                  +91 82482 38436
                </a>
              </div>
              <div>
                <p className="text-sm uppercase tracking-[3px] text-amber-400 font-bold mb-2">
                  Location
                </p>
                <p className="text-lg text-white">Vellore, Tamil Nadu</p>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <form onSubmit={handleSubmit} className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 p-8 space-y-6">
            <div>
              <label className="block text-xs uppercase tracking-[2px] text-gray-300 font-bold mb-3">
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full bg-black border border-gray-700 focus:border-amber-400 text-white px-4 py-3 outline-none transition"
                placeholder="Your Name"
              />
            </div>

            <div>
              <label className="block text-xs uppercase tracking-[2px] text-gray-300 font-bold mb-3">
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-black border border-gray-700 focus:border-amber-400 text-white px-4 py-3 outline-none transition"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="block text-xs uppercase tracking-[2px] text-gray-300 font-bold mb-3">
                Service Type *
              </label>
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="w-full bg-black border border-gray-700 focus:border-amber-400 text-white px-4 py-3 outline-none transition"
              >
                <option>Wedding</option>
                <option>Pre-Wedding</option>
                <option>Baby Shower</option>
                <option>Birthday</option>
                <option>Events</option>
              </select>
            </div>

            <div>
              <label className="block text-xs uppercase tracking-[2px] text-gray-300 font-bold mb-3">
                Event Date *
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                className="w-full bg-black border border-gray-700 focus:border-amber-400 text-white px-4 py-3 outline-none transition"
              />
            </div>

            <div>
              <label className="block text-xs uppercase tracking-[2px] text-gray-300 font-bold mb-3">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full bg-black border border-gray-700 focus:border-amber-400 text-white px-4 py-3 outline-none transition resize-none"
                placeholder="Tell us about your event..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-amber-400 text-black font-bold uppercase tracking-[2px] text-sm py-3 transition hover:bg-amber-500 flex items-center justify-center gap-2"
            >
              Send Inquiry
              <FiArrowUpRight size={16} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;